<template>
  <div>
    <vs-table :data="studentsEnrolledData" class="cstm_vuexy_table">
      <template slot="thead">
        <vs-th style="width: 80px">Image</vs-th>
        <vs-th> Name </vs-th>
        <vs-th> Email </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].picture">
            <img
              class="imgpic"
              v-if="data[indextr].picture"
              :src="data[indextr].picture"
              style="height: 40px; width: 40px; object-fit: contain"
            />
            <img
              class="imgpic"
              v-else
              src="http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg"
              style="height: 40px; width: 40px; object-fit: contain"
            />
          </vs-td>
          <vs-td
            >{{ data[indextr].first_name }}
            {{ data[indextr].last_name }}
          </vs-td>
          <vs-td>
            {{ data[indextr].email }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    studentsEnrolledData: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
